const en = {
  // Header
  'header.logoAlt': 'Korebaps Logo',

  // Footer
  'footer.copyright': '© 2026 Korebaps Stats Dashboard. All rights reserved.',
  'footer.createdBy': 'Created by Junsu Yoon #17 and Taerim Kim #66',

  // Visitor Banner
  'visitor.unavailable': 'Visitor stats unavailable',
  'visitor.loading': 'Loading visitor stats...',
  'visitor.today': 'Today',
  'visitor.month': 'Month',
  'visitor.total': 'Total',

  // Common
  'common.loading': 'Loading...',
  'common.home': 'Home',
  'common.activeRoster': 'Active Roster',
  'common.gameRecords': 'Game Records',
  'common.videos': 'Videos',
  'common.roster': 'Roster',
  'common.admin': 'Admin',
  'common.allSeasons': 'All Seasons',
  'common.selectSeason': 'Select Season',
  'common.currentSeason': 'Current Season',
  'common.player': 'Player',
  'common.date': 'Date',
  'common.opponent': 'Opponent',
  'common.score': 'Score',
  'common.season': 'Season',
  'common.status': 'Status',
  'common.close': 'Close',
  'common.refresh': 'Refresh',
  'common.exportCSV': 'Export CSV',
  'common.myStats': 'My Stats',
  'common.pinPlayerPrompt': 'Pin your player from the Roster to see your stats here',
  'suffix.players': '',
  'suffix.games': ' games',

  // App (Main Dashboard)
  'app.title': 'Korebaps Player Stats',
  'app.subtitle': 'Korebaps Stats Dashboard',
  'app.latestGame': 'Latest Game',
  'app.registeredPlayers': 'Players',
  'app.games': 'Games',
  'app.seasonSelect': 'Select Season',
  'app.loadingSeasons': 'Loading seasons...',
  'app.searchPlayer': 'Search player...',
  'app.includeRetired': 'Include Retired',
  'app.battingStats': 'Batting Stats',
  'app.pitchingStats': 'Pitching Stats',
  'app.runsAllowed': 'RA',
  'app.earnedRuns': 'ER',
  'app.pitchCount': 'Pitches',

  // Player Detail
  'player.title': 'Korebaps Player Stats',
  'player.subtitle': 'Korebaps Stats Dashboard',
  'player.name': 'Player',
  'player.jerseyNumber': 'Jersey #',
  'player.selectedSeason': 'Season',
  'player.notFound': 'Player not found.',
  'player.inactiveMsg': 'This player is currently',
  'player.inactiveStatus': 'Inactive',
  'player.noAlbumArt': 'No album art',
  'player.walkupSong': 'Walkup Song',
  'player.openSpotify': 'Open in Spotify',
  'player.careerBatting': 'Career Batting',
  'player.careerPitching': 'Career Pitching',
  'player.noBattingStats': 'No career batting stats.',
  'player.noPitchingStats': 'No career pitching stats.',
  'player.gameBattingStats': 'Game Batting Stats',
  'player.battingTrend': 'Batting Trend (Cumulative AVG/OBP/SLG)',
  'player.gamePitchingStats': 'Game Pitching Stats',
  'player.noGameRecords': 'No game records found.',
  'player.pinMyStats': 'Pin as My Stats',
  'player.unpinMyStats': 'Unpin from My Stats',
  'player.shareLink': 'Share',
  'player.linkCopied': 'Link copied!',
  'player.compareSeasons': 'Compare Seasons',
  'player.seasonA': 'Season A',
  'player.seasonB': 'Season B',
  'player.selectTwoSeasons': 'Select two seasons to compare.',

  // Player Comparison
  'compare.title': 'Player Comparison',
  'compare.subtitle': 'Compare two players head-to-head',
  'compare.selectPlayerA': 'Player A',
  'compare.selectPlayerB': 'Player B',
  'compare.selectTwoPlayers': 'Select two players to compare.',
  'compare.batting': 'Batting',
  'compare.pitching': 'Pitching',
  'common.comparePlayers': 'Compare Players',

  // Active Roster
  'roster.title': 'Korebaps Active Roster',
  'roster.subtitle': 'Korebaps Active Roster',
  'roster.totalPlayers': 'Players',
  'roster.updated': 'Updated',
  'roster.activeRoster': 'Active Roster',
  'roster.inactiveRoster': 'Inactive Roster',
  'roster.clickExpand': '(click to expand)',
  'roster.noActive': 'No active players found.',
  'roster.noInactive': 'No inactive players found.',

  // Game Records
  'games.title': 'Korebaps Game Records',
  'games.subtitle': 'Korebaps Game Records',
  'games.totalGames': 'Total Games',
  'games.selected': 'Selected',
  'games.all': 'All',
  'games.heading': 'Game Records',
  'games.sortedRecent': 'Sorted by most recent.',
  'games.noRecords': 'No game records found.',
  'games.friendly': 'Friendly',
  'games.regular': 'Regular',
  'games.win': 'W',
  'games.loss': 'L',
  'games.draw': 'D',
  'games.score': 'Score',

  // Game Detail
  'gameDetail.title': 'Korebaps Game Detail',
  'gameDetail.subtitle': 'Korebaps Game Detail',
  'gameDetail.gameDate': 'Game Date',
  'gameDetail.battingStats': 'Game Batting Stats',
  'gameDetail.pitchingStats': 'Game Pitching Stats',
  'gameDetail.notFound': 'Game not found.',
  'gameDetail.noBatting': 'No batting records found.',
  'gameDetail.noPitching': 'No pitching records found.',

  // Videos
  'videos.title': 'Korebaps Videos',
  'videos.subtitle': 'Korebaps Videos',
  'videos.subscribe': 'Subscribe',
  'videos.nowPlaying': 'Now Playing',
  'videos.latestVideos': 'Latest Videos',
  'videos.viewAll': 'View All',
  'videos.loadError': 'Failed to load videos.',
  'videos.noVideos': 'No videos available.',
  'videos.tryLater': 'Please try again later.',
  'videos.visitChannel': 'Visit our YouTube channel for more videos!',
  'videos.viewAllYouTube': 'View All on YouTube',

  // Point Table
  'points.heading': 'Point Table',
  'points.rules': 'Korebaps Score Rules',
  'points.batting': 'Batting',
  'points.pitching': 'Pitching',

  // Stat tooltips (abbreviations)
  'stat.pa': 'Plate Appearances',
  'stat.ab': 'At Bats',
  'stat.1b': 'Singles',
  'stat.2b': 'Doubles',
  'stat.3b': 'Triples',
  'stat.hr': 'Home Runs',
  'stat.r': 'Runs',
  'stat.rbi': 'Runs Batted In',
  'stat.bb': 'Walks',
  'stat.hbp': 'Hit By Pitch',
  'stat.so': 'Strikeouts',
  'stat.sb': 'Stolen Bases',
  'stat.cs': 'Caught Stealing',
  'stat.avg': 'Batting Average',
  'stat.obp': 'On-Base Percentage',
  'stat.slg': 'Slugging Percentage',
  'stat.ops': 'On-Base Plus Slugging',
  'stat.war': 'Wins Above Replacement',
  'stat.g': 'Games Played',
  'stat.ip': 'Innings Pitched',
  'stat.w': 'Wins',
  'stat.ra': 'Runs Allowed',
  'stat.er': 'Earned Runs',
  'stat.h': 'Hits Allowed',
  'stat.point': 'Batting Points',
  'stat.score': 'Score',
  'stat.pitches': 'Pitches Thrown',
  'stat.era': 'Earned Run Average',
  'stat.whip': 'Walks + Hits per Inning Pitched',
  'stat.k9': 'Strikeouts per 9 Innings',

  // Guide (hidden page - /guide)
  'guide.title': 'Korebaps Stats Guide',
  'guide.subtitle': 'Feature guide and tutorial',
  'guide.pageLabel': 'Page',
  'guide.pageValue': 'Guide',
  'guide.introTitle': 'Welcome to the Korebaps Stats Guide',
  'guide.introContent': 'This guide walks you through the main features of the Korebaps Stats Dashboard. Use the sections below to learn how to get the most out of the app.',
  'guide.featuresTitle': 'Features',
  'guide.quickStart': 'Quick Start',
  'guide.quickStartContent': '1. Go to Roster to browse all players.\n2. Click a player to view their stats.\n3. On their page, click "Pin as My Stats" to save them for quick access.\n4. Your pinned player will appear in the header on the home page.',
  'guide.dashboard': 'Dashboard',
  'guide.dashboardContent': 'The home page shows batting and pitching stats for the whole team. Use the season dropdown to filter by season, or select "All Seasons" for career totals. Use the search box to find specific players. Check "Include Retired" to see inactive players. Click any row to open that player\'s detail page.',
  'guide.myStats': 'My Stats',
  'guide.myStatsContent': 'The third card in the header shows "My Stats." If you haven\'t pinned a player yet, it will prompt you to visit the Roster and pin one. Once pinned, clicking the card takes you directly to your player\'s stats page.',
  'guide.playerPage': 'Player Page',
  'guide.playerPageContent': 'Each player has a detail page with career stats, game-by-game logs, batting trend charts, and season comparison. Use the Share button to copy a link to the page. Export CSV buttons let you download career stats or game logs.',
  'guide.compare': 'Compare Players',
  'guide.compareContent': 'Go to Compare Players to select two players and view their batting and pitching stats side by side. Useful for comparing teammates or tracking progress.',
  'guide.export': 'Export CSV',
  'guide.exportContent': 'CSV export is available on the dashboard (batting and pitching tables) and on player pages (career stats and game logs). Click "Export CSV" to download the data. Files use UTF-8 so Korean characters display correctly in Excel.',
  'guide.share': 'Share',
  'guide.shareContent': 'On a player\'s page, use the Share button to copy the page URL to your clipboard. You can paste and send it to others so they can view the same player\'s stats.',
  'guide.tips': 'Tip: Hover over stat abbreviations (PA, OBP, etc.) for full definitions.',

  // Admin Guide (hidden page - /admin_guide)
  'adminGuide.title': 'Admin Guide',
  'adminGuide.subtitle': 'Korebaps Stats Admin — Complete reference',
  'adminGuide.pageLabel': 'Page',
  'adminGuide.pageValue': 'Admin Guide',
  'adminGuide.goToAdmin': 'Go to Admin',
  'adminGuide.confidentialTitle': 'Confidential — Admin Only',
  'adminGuide.confidentialContent': 'This guide is for authorized administrators only. Do not share the admin password or this guide with non-admins.',
  'adminGuide.introTitle': 'Admin Dashboard Overview',
  'adminGuide.introContent': 'The admin dashboard at /admin lets you manage seasons, players, games, and stats. You must log in with the admin password first. This guide walks you through every feature step by step.',
  'adminGuide.sectionsTitle': 'Sections',
  'adminGuide.overview': 'Overview',
  'adminGuide.overviewContent': 'The admin has 4 main tabs: Players (선수 관리), Seasons (시즌 관리), Games (경기 관리), and CSV Upload (CSV 업로드). There is also a "수동 입력" (Manual Entry) dropdown with Batting (타격 기록) and Pitching (투구 기록).\n\nWorkflow order: 1) Create seasons. 2) Add players. 3) Create games. 4) Add stats via CSV or manual entry. 5) Edit stats or add walkup songs as needed.',
  'adminGuide.login': 'Login',
  'adminGuide.loginContent': 'Go to /admin. Enter the admin password and click Sign In. The password is set by the backend. If you forget it, contact the system administrator. After login, you stay authenticated until you close the browser or the session expires.',
  'adminGuide.seasons': 'Seasons',
  'adminGuide.seasonsContent': 'Create a new season: Enter Year (e.g. 2026), Term (e.g. Spring, Summer, Fall), and optionally select a Manager from the player list. Click "시즌 생성" (Create Season).\n\nClick a season in the list to select it and jump to the Games tab. You must select a season before creating games.',
  'adminGuide.players': 'Players',
  'adminGuide.playersContent': 'Add Player: Fill First Name, Last Name, Jersey #, and check Active (활성) if the player is currently on the roster. Click "추가" (Add).\n\nEdit Player: Click the name to edit first/last name, or click the jersey number to change it. Use the checkmark to save, X to cancel.\n\nToggle Active: Use the "활성" / "비활성" button to mark a player as active or retired. Inactive players appear dimmed and can be hidden on the public site with "Include Retired" unchecked.',
  'adminGuide.games': 'Games',
  'adminGuide.gamesContent': 'Create Game: Select a season first. Enter Game Date, Opponent, and optionally Score / Opp Score. Check "친선" (Friendly) for exhibition games. Click "경기 추가" (Add Game).\n\nGames show a green dot when they have batting/pitching stats, gray when empty. Click a game card to expand and edit its stats.\n\nDelete Game: Click the trash icon on a game. This will delete the game and all its batting/pitching records. Confirm carefully.',
  'adminGuide.editStats': 'Editing Game Stats',
  'adminGuide.editStatsContent': 'Click a game in the Games tab to expand the stats editor. You will see Batting (타격 기록) and Pitching (투구 기록) sections.\n\nTo edit a row: Click the row. Inputs appear. Change values (PA, 1B, 2B, HR, etc. for batting; IP, H, R, ER, SO, etc. for pitching). Check MVP if applicable. Click "저장" (Save) or "취소" (Cancel).\n\nPitching IP: Enter outs recorded (e.g. 9 for 3 IP, 10 for 3.1 IP). The system converts to innings displayed.',
  'adminGuide.csvUpload': 'CSV Upload',
  'adminGuide.csvUploadContent': 'Use CSV Upload to bulk-import batting and pitching stats for a game. The CSV must have a specific format:\n\nRow 1: Category labels (Batting, Pitching, Fielding)\nRow 2: Column headers (PA, 1B, 2B, HR, R, RBI, BB, SO, HBP, SB, CS for batting; IP, #P, H, R, ER, SO, BB, HBP, W, L, SV for pitching)\nRow 3+: Player rows with jersey number, name, and stat values\n\nSelect the target game and season. Upload the CSV. The system will match players by jersey/name. Review the preview, fix any mismatches, then confirm to import. This overwrites existing stats for that game.',
  'adminGuide.manualEntry': 'Manual Entry (Batting / Pitching)',
  'adminGuide.manualEntryContent': 'Use "수동 입력" → "타격 기록" or "투구 기록" to add stats one player at a time.\n\nSelect a Game and a Player from the dropdowns. Fill in the form (PA, AB, 1B, 2B, 3B, HR, etc. for batting; IP, W, K, R, ER, H, BB, etc. for pitching). Submit.\n\nManual entry is useful for adding a single player\'s stats or correcting one record without re-uploading a full CSV.',
  'adminGuide.walkup': 'Walkup Songs',
  'adminGuide.walkupContent': 'In the Players tab, click a player card to select them. The walkup song section appears on the right.\n\nEnter Song Title, Artist Name, and optionally Spotify Track ID (or full Spotify URL). Set Start (sec) if the song should start at a specific second (e.g. 30 to skip intro). Click "저장" (Save).\n\nThe walkup song appears on the player\'s public page with a Spotify embed if the track ID is provided.',
  'adminGuide.workflow': 'Recommended Workflow',
  'adminGuide.workflowContent': '1. Create the season (e.g. 2026 Spring) before starting.\n2. Add all players who will play this season. Mark retirees as inactive.\n3. After each game, create the game record with date, opponent, and score.\n4. Add stats: Use CSV upload if you have a full box score; otherwise use manual entry.\n5. Review and edit any incorrect stats in the game stats editor.\n6. Add walkup songs for players who want them.\n\nTip: Always select the correct season before creating games. Stats are tied to games, which are tied to seasons.',

  // Record Summary
  'summary.heading': 'Game Summary',
  'summary.battingTop3': 'Batting Top 3',
  'summary.pitchingTop3': 'Pitching Top 3',
  'summary.noBatting': 'No batting records found.',
  'summary.noPitching': 'No pitching records found.',
};

export default en;
